// Build447: normalize QR-overlapping NFC geometry before rendering/restoring.
// Build414: coordinated multi-selection; historical predecessor retained.
// Build405: Italian editor localization; historical predecessor retained.
// Build 20260909-324: axis preferences and canonical keyboard movement.
(() => {
  "use strict";
  if (window.__smoofNfcEditorV03Build324) return;
  window.__smoofNfcEditorV03Build324 = true;
  window.__smoofNfcEditorV03 = !0;

  /* Verhindert, dass ein später eingebundener Legacy-Editor erneut patcht. */
  window.__smoofNfcEditorV02 = !0;
  const VERSION = "0.7.0",
    STAGE_SELECTOR = ".po-livePreview-stage .konvajs-content",
    ICON_URL =
      "https://cdn.shopify.com/s/files/1/0996/4136/0721/files/NFC_ICON_8eab0b33-09c2-410e-a79e-a0a23be2ec72.svg?v=1785497558",
    DEFAULT_SIZE = 78,
    PRINT_RADIUS = 353.4,
    PRINT_EDGE_GAP = 10,
    QR_WHITE_BOX = { minX: 425, maxX: 575, minY: 425, maxY: 575 },
    DEFAULT_STATE = Object.freeze({
      x: 500,
      y: 500,
      scale: 1,
      visible: !0,
      iconColor: "#0d0d0d",
      circleColor: "#ffffff",
      circleTransparent: !1,
    }),
    PROPERTY_NAMES = {
      x: "properties[_SMOOF NFC X]",
      y: "properties[_SMOOF NFC Y]",
      scale: "properties[_SMOOF NFC Skalierung]",
      visible: "properties[_SMOOF NFC sichtbar]",
      iconColor: "properties[_SMOOF NFC Symbolfarbe]",
      circleColor: "properties[_SMOOF NFC Kreisfarbe]",
      circleTransparent: "properties[_SMOOF NFC Kreis transparent]",
    };
  let frame = null,
    panel = null,
    active = !1,
    dragging = !1,
    dragMoved = !1,
    dragStart = null,
    renderPending = !1,
    panelOpen = !1,
    iconSvgPromise = null,
    liveIconTemplate = null,
    liveIconTemplatePromise = null,
    sourcesHydrated = !1;
  const state = { ...DEFAULT_STATE },
    clamp = (value, min, max) => Math.min(max, Math.max(min, value)),
    t = (de, en) =>
      window.SmoofI18n.copy(de, en);
  function normalizeHex(value, fallback) {
    const match = String(value || "")
      .trim()
      .match(/^#([0-9a-f]{6})(?:[0-9a-f]{2})?$/i);
    return match ? `#${match[1].toLowerCase()}` : fallback;
  }
  function hexWithAlpha(value) {
    return `${normalizeHex(value, "#000000")}ff`.toUpperCase();
  }
  function truthy(value) {
    return /^(1|true|yes|ja)$/i.test(String(value || "").trim());
  }
  function qrInnerBox(snapshot = null) {
    const qr = snapshot || window.SmoofQrGeometryTools?.getState?.();
    if (!qr) return { ...QR_WHITE_BOX, centerX: 500, centerY: 500 };
    const centerX = (Number(qr.x) || 0.5) * 1000,
      centerY = (Number(qr.y) || 0.5) * 1000,
      /* Include the full QR panel: partial edge overlaps must also centre. */
      half = (256 * Math.max(0.5, Math.min(1.5, Number(qr.scale) || 1))) / 2;
    return {
      minX: centerX - half,
      maxX: centerX + half,
      minY: centerY - half,
      maxY: centerY + half,
      centerX,
      centerY,
    };
  }
  function safePosition(x, y) {
    const half = (DEFAULT_SIZE * clamp(Number(state.scale) || 1, 0.1, 4)) / 2,
      dx = x - 500,
      dy = y - 500,
      distance = Math.hypot(dx, dy),
      maxDistance = PRINT_RADIUS - half - PRINT_EDGE_GAP;
    let safeX = x,
      safeY = y;
    if (distance > maxDistance && distance > 0) {
      const factor = maxDistance / distance;
      ((safeX = 500 + dx * factor), (safeY = 500 + dy * factor));
    }
    const qrBox = qrInnerBox(),
      exclusion = {
      minX: qrBox.minX - half - 4,
      maxX: qrBox.maxX + half + 4,
      minY: qrBox.minY - half - 4,
      maxY: qrBox.maxY + half + 4,
    };
    return safeX > exclusion.minX &&
      safeX < exclusion.maxX &&
      safeY > exclusion.minY &&
      safeY < exclusion.maxY
      ? { x: qrBox.centerX, y: qrBox.centerY }
      : { x: safeX, y: safeY };
  }
  function normalizeGeometry() {
    const position = safePosition(state.x, state.y), qr = window.SmoofQrGeometryTools?.getState?.();
    const attached = qr && Math.hypot(position.x - qr.x * 1000, position.y - qr.y * 1000) < 0.01;
    const scale = attached ? clamp(Number(qr.scale) || 1, 0.1, 4) : state.scale;
    const changed = position.x !== state.x || position.y !== state.y || scale !== state.scale;
    state.x = position.x; state.y = position.y; state.scale = scale;
    if (changed) saveState();
  }
  function productForm() {
    return (
      Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(
        (form) => form.querySelector('button[type="submit"]'),
      ) || null
    );
  }
  function propertyInput(name) {
    return (
      Array.from((productForm() || document).querySelectorAll("input")).find(
        (input) => input.name === name && input.type !== "file",
      ) || null
    );
  }
  function propertyValue(name) {
    return propertyInput(name)?.value || "";
  }
  function setProperty(name, value) {
    const form = productForm();
    if (!form) return;
    let input = propertyInput(name);
    (input ||
      ((input = document.createElement("input")),
      (input.type = "hidden"),
      (input.name = name),
      form.appendChild(input)),
      (input.value = String(value)));
  }
  function fieldRoot(role) {
    return window.SmoofProductMaster?.fieldRoot?.(role) || null;
  }
  function sourceColor(role, fallback) {
    const root = fieldRoot(role),
      value =
        root?.querySelector('input[type="hidden"]')?.value ||
        root?.querySelector('input[type="color"]')?.value ||
        fallback;
    return normalizeHex(value, fallback);
  }
  function setNativeValue(input, value) {
    if (!input) return;
    const descriptor = Object.getOwnPropertyDescriptor(
      HTMLInputElement.prototype,
      "value",
    );
    (descriptor?.set
      ? descriptor.set.call(input, value)
      : (input.value = value),
      input.dispatchEvent(new Event("input", { bubbles: !0 })),
      input.dispatchEvent(new Event("change", { bubbles: !0 })));
  }
  function writeSourceColor(role, color) {
    const root = fieldRoot(role);
    if (!root) return;
    const eight = hexWithAlpha(color);
    root.querySelectorAll("input").forEach((input) => {
      const value =
        input.type === "color" ||
        input.type === "text" ||
        input.type === "hidden"
          ? eight
          : input.value;
      value !== input.value && setNativeValue(input, value);
    });
  }
  function loadState() {
    state.scale = clamp(Number.parseFloat(propertyValue(PROPERTY_NAMES.scale)) || 1, 0.1, 4);
    const x = Number.parseFloat(propertyValue(PROPERTY_NAMES.x)),
      y = Number.parseFloat(propertyValue(PROPERTY_NAMES.y)),
      position = safePosition(
        Number.isFinite(x) ? x : 500,
        Number.isFinite(y) ? y : 500,
      );
    ((state.x = position.x), (state.y = position.y));
    const visible = propertyValue(PROPERTY_NAMES.visible);
    ((state.visible = visible === "" ? !0 : truthy(visible)),
      (state.iconColor = normalizeHex(
        propertyValue(PROPERTY_NAMES.iconColor),
        sourceColor("nfcIconColor", "#0d0d0d"),
      )),
      (state.circleColor = normalizeHex(
        propertyValue(PROPERTY_NAMES.circleColor),
        sourceColor("nfcCircleColor", "#ffffff"),
      )),
      (state.circleTransparent = truthy(
        propertyValue(PROPERTY_NAMES.circleTransparent),
      )));
  }
  function saveState({ syncSource = !1 } = {}) {
    (setProperty(PROPERTY_NAMES.x, state.x.toFixed(2)),
      setProperty(PROPERTY_NAMES.y, state.y.toFixed(2)),
      setProperty(PROPERTY_NAMES.scale, state.scale.toFixed(3)),
      setProperty(PROPERTY_NAMES.visible, state.visible ? "Ja" : "Nein"),
      setProperty(PROPERTY_NAMES.iconColor, state.iconColor),
      setProperty(PROPERTY_NAMES.circleColor, state.circleColor),
      setProperty(
        PROPERTY_NAMES.circleTransparent,
        state.circleTransparent ? "Ja" : "Nein",
      ),
      syncSource &&
        (writeSourceColor("nfcIconColor", state.iconColor),
        writeSourceColor("nfcCircleColor", state.circleColor)));
  }
  function nfcEnabled() {
    const variant = window.SmoofProductVariant?.get?.();
    if (variant && typeof variant.nfcEnabled == "boolean")
      return variant.nfcEnabled;
    const checked = Array.from(
      document.querySelectorAll('input[type="radio"]'),
    ).find(
      (input) =>
        input.checked &&
        /nfc/i.test(input.closest("label")?.textContent || input.value),
    );
    return !!(
      checked &&
      !/ohne|without|no\s+nfc/i.test(
        checked.closest("label")?.textContent || checked.value,
      )
    );
  }
  function personalized() {
    return window.SmoofProductMaster?.selectedPersonalizedDesign?.() === !0;
  }
  function shouldShow() {
    return personalized() && nfcEnabled();
  }
  function stage() {
    return document.querySelector(STAGE_SELECTOR);
  }
  function iconSvgIn(root = document) {
    return (
      Array.from(
        root.querySelectorAll?.(
          '[data-smoof-vector-preview] > svg, svg[viewBox="0 0 109.77 109.77"]',
        ) || [],
      ).find((svg) => !svg.hasAttribute("data-smoof-nfc-live-svg") && svg.getAttribute("viewBox") === "0 0 109.77 109.77") ||
      null
    );
  }
  function applyColours(svg) {
    svg &&
      (svg
        .querySelectorAll(".cls-2")
        .forEach((node) => (node.style.fill = state.iconColor)),
      svg
        .querySelectorAll(".cls-3")
        .forEach(
          (node) =>
            (node.style.fill = state.circleTransparent
              ? "none"
              : state.circleColor),
        ));
  }
  function applyNfcToSvg(root) {
    const svg = iconSvgIn(root);
    if (!svg) return !1;
    const size = DEFAULT_SIZE * clamp(Number(state.scale) || 1, 0.1, 4);
    return (
      svg.style.setProperty("opacity", "0", "important"),
      svg.setAttribute("x", String(state.x - size / 2)),
      svg.setAttribute("y", String(state.y - size / 2)),
      svg.setAttribute("width", String(size)),
      svg.setAttribute("height", String(size)),
      applyColours(svg),
      (svg.dataset.smoofNfcVector = "true"),
      svg.style.removeProperty("opacity"),
      !0
    );
  }
  function mountLiveIcon(target) {
    if (!target || !liveIconTemplate) return null;
    const existing = target.querySelector("[data-smoof-nfc-live-svg]"),
      svg = existing || liveIconTemplate.cloneNode(!0);
    return (
      existing ||
        ((svg.dataset.smoofNfcLiveSvg = "true"),
        svg.removeAttribute("x"),
        svg.removeAttribute("y"),
        svg.removeAttribute("width"),
        svg.removeAttribute("height"),
        svg.setAttribute("aria-hidden", "true"),
        target.appendChild(svg)),
      applyColours(svg),
      svg
    );
  }
  function ensureLiveIcon() {
    const target = ensureFrame();
    if (target) {
      if (liveIconTemplate) {
        mountLiveIcon(target);
        return;
      }
      (liveIconTemplatePromise ||
        (liveIconTemplatePromise = iconSvgText()
          .then((text) => {
            const svg = new DOMParser().parseFromString(
              text,
              "image/svg+xml",
            ).documentElement;
            if (!svg || svg.nodeName.toLowerCase() !== "svg")
              throw new Error("Invalid NFC SVG");
            return (
              (liveIconTemplate = document.importNode(svg, !0)),
              liveIconTemplate
            );
          })
          .catch(
            (error) => (
              (liveIconTemplatePromise = null),
              console.warn("SMOOF NFC live icon unavailable", error),
              null
            ),
          )),
        liveIconTemplatePromise.then((template) => {
          !template || !active || mountLiveIcon(ensureFrame());
        }));
    }
  }
  function ensureFrame() {
    const target = stage();
    return target
      ? ((frame?.isConnected && frame.parentNode === target) ||
          (frame?.remove(),
          (frame = document.createElement("button")),
          (frame.type = "button"),
          (frame.dataset.smoofNfcFrame = "true"),
          (frame.dataset.smoofEditorItem = "nfc"),
          frame.setAttribute(
            "aria-label",
            t("NFC-Symbol bearbeiten", "Edit NFC symbol"),
          ),
          frame.addEventListener("pointerdown", startDrag),
          frame.addEventListener("pointermove", moveDrag),
          frame.addEventListener("pointerup", endDrag),
          frame.addEventListener("pointercancel", endDrag),
          frame.addEventListener("click", (event) => {
            (event.stopPropagation(),
              dragMoved || openPanel(),
              (dragMoved = !1));
          }),
          target.appendChild(frame),
          liveIconTemplate && mountLiveIcon(frame)),
        frame)
      : null;
  }
  function updateFrame() {
    const target = ensureFrame();
    if (!target) return;
    const size = DEFAULT_SIZE * clamp(Number(state.scale) || 1, 0.1, 4);
    ((target.style.left = `${(state.x - size / 2) / 10}%`),
      (target.style.top = `${(state.y - size / 2) / 10}%`),
      (target.style.width = `${size / 10}%`),
      (target.style.height = `${size / 10}%`),
      /* Die verschiebbare QR-Ebene ist eine DOM-Ebene. Das NFC-Element muss
       * darüber liegen, damit Symbol und Kreis nicht vom QR-Button verdeckt
       * werden. */
      (target.style.zIndex = "2147482500"),
      (target.hidden = !active || !state.visible),
      (target.dataset.selected = panelOpen ? "true" : "false"));
    // The presentation adapter may last have measured this layer while hidden
    // (offsetLeft/Top = 0). Refresh its origin synchronously before it is painted.
    if (!target.hidden && target.dataset.smoofStandingArtworkLayer &&
        document.documentElement.dataset.smoofQhsMode === "product") {
      const parent = target.parentElement;
      target.style.setProperty("transform-origin",
        `${parent.clientWidth / 2 - target.offsetLeft}px ${parent.clientHeight / 2 - target.offsetTop}px`, "important");
    }
  }
  function startDrag(event) {
    !active ||
      event.button !== 0 ||
      ((dragging = !0),
      (dragMoved = !1),
      (dragStart = {
        clientX: event.clientX,
        clientY: event.clientY,
        x: state.x,
        y: state.y,
      }),
      frame.setPointerCapture?.(event.pointerId),
      event.preventDefault(),
      event.stopPropagation());
  }
  function moveDrag(event) {
    if (!dragging || !dragStart) return;
    const rect = stage()?.getBoundingClientRect();
    if (!rect?.width || !rect?.height) return;
    const dx = ((event.clientX - dragStart.clientX) / rect.width) * 1e3,
      dy = ((event.clientY - dragStart.clientY) / rect.height) * 1e3;
    dragMoved = dragMoved || Math.abs(dx) + Math.abs(dy) > 2;
    let position = safePosition(dragStart.x + dx, dragStart.y + dy);
    const sharedGuides = window.SmoofAlignmentGuides,
      guideAtX = sharedGuides?.nearestX(position.x / 1e3, 0.012),
      guideAtY = sharedGuides?.nearestY?.(position.y / 1e3, 0.012);
    if (Number.isFinite(guideAtX)) {
      position = safePosition(guideAtX * 1e3, position.y);
      sharedGuides.showX(guideAtX);
    } else {
      sharedGuides?.hideX();
    }
    if (Number.isFinite(guideAtY)) {
      position = safePosition(position.x, guideAtY * 1e3);
      sharedGuides.showY?.(guideAtY);
    } else {
      sharedGuides?.hideY?.();
    }
    ((state.x = position.x),
      (state.y = position.y),
      updateAll(),
      event.preventDefault(),
      event.stopPropagation());
  }
  function endDrag(event) {
    if (!dragging) return;
    const shouldOpen = !dragMoved;
    ((dragging = !1),
      (dragStart = null),
      window.SmoofAlignmentGuides?.hideAll?.(),
      frame.releasePointerCapture?.(event.pointerId),
      saveState(),
      window.SmoofDesignRenderer?.scheduleRender?.(),
      event.preventDefault(),
      event.stopPropagation(),
      shouldOpen && requestAnimationFrame(openPanel));
  }
  function panelMarkup() {
    return `
      <header>
        <span data-smoof-nfc-panel-symbol aria-hidden="true">N</span>
        <span><strong>NFC</strong><small>${t("Symbol und Kreisfl\xE4che", "Icon and circle")}</small></span>
        <button type="button" data-smoof-nfc-close aria-label="${t("Schlie\xDFen", "Close")}">\xD7</button>
      </header>
      <div data-smoof-nfc-panel-body>
        <label><span>${t("Symbolfarbe", "Icon colour")}</span><input type="color" data-smoof-nfc-color="icon" value="${state.iconColor}"><output>${state.iconColor.toUpperCase()}</output></label>
        <label data-smoof-nfc-circle-color data-disabled="${state.circleTransparent ? "true" : "false"}"><span>${t("Kreisfarbe", "Circle colour")}</span><input type="color" data-smoof-nfc-color="circle" value="${state.circleColor}" ${state.circleTransparent ? "disabled" : ""}><output>${state.circleColor.toUpperCase()}</output></label>
        <label data-smoof-nfc-transparency><span>${t("Kreisfl\xE4che", "Circle fill")}</span><strong>${state.circleTransparent ? t("Transparent", "Transparent") : t("Farbig", "Coloured")}</strong><span data-smoof-nfc-switch><input type="checkbox" data-smoof-nfc-transparent ${state.circleTransparent ? "checked" : ""}><span aria-hidden="true"></span></span></label>
        <p>${t("Im QR-Code nur mittig. Au\xDFerhalb der QR-Schutzzone frei platzierbar.", "Centred only inside the QR code. Freely positionable outside the QR protection zone.")}</p>
        <button type="button" data-smoof-nfc-reset>${t("Position zur\xFCcksetzen", "Reset position")}</button>
      </div>`;
  }
  function ensurePanel() {
    return (
      panel?.isConnected ||
        ((panel = document.createElement("section")),
        (panel.dataset.smoofNfcControls = "true"),
        (panel.hidden = !0),
        panel.addEventListener("pointerdown", (event) =>
          event.stopPropagation(),
        ),
        panel.addEventListener("click", (event) => {
          (event.stopPropagation(),
            event.target.closest("[data-smoof-nfc-close]") && closePanel(),
            event.target.closest("[data-smoof-nfc-reset]") &&
              ((state.x = qrInnerBox().centerX),
              (state.y = qrInnerBox().centerY),
              (state.scale = 1),
              saveState(),
              renderPanel(),
              updateAll()));
        }),
        panel.addEventListener("input", (event) => {
          const type = event.target?.dataset?.smoofNfcColor;
          (type === "icon" &&
            (state.iconColor = normalizeHex(
              event.target.value,
              state.iconColor,
            )),
            type === "circle" &&
              (state.circleColor = normalizeHex(
                event.target.value,
                state.circleColor,
              )),
            type &&
              (saveState({ syncSource: !0 }), renderPanel(!1), updateAll()),
            event.target?.matches?.("[data-smoof-nfc-transparent]") &&
              ((state.circleTransparent = event.target.checked),
              saveState(),
              renderPanel(),
              updateAll()));
        }),
        document.body.appendChild(panel)),
      panel
    );
  }
  function renderPanel(replace = !0) {
    const target = ensurePanel();
    if (replace) target.innerHTML = panelMarkup();
    else {
      const icon = target.querySelector('[data-smoof-nfc-color="icon"]'),
        circle = target.querySelector('[data-smoof-nfc-color="circle"]');
      (icon &&
        document.activeElement !== icon &&
        (icon.value = state.iconColor),
        circle &&
          document.activeElement !== circle &&
          (circle.value = state.circleColor));
      const outputs = target.querySelectorAll("label output");
      (outputs[0] && (outputs[0].textContent = state.iconColor.toUpperCase()),
        outputs[1] &&
          (outputs[1].textContent = state.circleColor.toUpperCase()));
      const circleOutput = target.querySelector(
        "[data-smoof-nfc-circle-color] output",
      );
      circleOutput &&
        (circleOutput.textContent = state.circleColor.toUpperCase());
    }
    positionPanel();
  }
  function resetNfcLayout() {
    const position = safePosition(DEFAULT_STATE.x, DEFAULT_STATE.y);
    ((state.x = position.x),
      (state.y = position.y),
      (state.scale = DEFAULT_STATE.scale),
      saveState(),
      panelOpen && renderPanel(),
      updateAll(),
      window.SmoofDesignRenderer?.scheduleRender?.());
  }
  function resetNfcContent() {
    ((state.iconColor = DEFAULT_STATE.iconColor),
      (state.circleColor = DEFAULT_STATE.circleColor),
      (state.circleTransparent = DEFAULT_STATE.circleTransparent),
      (state.visible = DEFAULT_STATE.visible),
      saveState({ syncSource: !0 }),
      panelOpen && renderPanel(),
      updateAll(),
      window.SmoofDesignRenderer?.scheduleRender?.(),
      window.dispatchEvent(
        new CustomEvent("smoof:nfc-visibility-changed", {
          detail: { visible: state.visible },
        }),
      ));
  }
  function positionPanel() {
    if (!panelOpen || !panel || !frame) return;
    if (matchMedia("(max-width: 749px)").matches) {
      (panel.style.removeProperty("left"), panel.style.removeProperty("top"));
      return;
    }
    const anchor = frame.getBoundingClientRect(),
      box = panel.getBoundingClientRect();
    let left = anchor.right + 14;
    left + box.width > innerWidth - 12 && (left = anchor.left - box.width - 14);
    let top = anchor.top + (anchor.height - box.height) / 2;
    ((left = clamp(left, 12, innerWidth - box.width - 12)),
      (top = clamp(top, 82, innerHeight - box.height - 12)),
      (panel.style.left = `${Math.round(left)}px`),
      (panel.style.top = `${Math.round(top)}px`));
  }
  function openPanel() {
    if (active) {
      const openContext = panelOpen;
      if (
        (window.dispatchEvent(
          new CustomEvent("smoof:editor-select", { detail: { id: "nfc", openContext } }),
        ),
        document.documentElement.dataset.smoofUiShellReady === "true")
      ) {
        ((panelOpen = !0), panel && (panel.hidden = !0), updateFrame());
        return;
      }
      ((panelOpen = !0),
        renderPanel(),
        (panel.hidden = !1),
        requestAnimationFrame(positionPanel),
        updateFrame());
    }
  }
  function closePanel() {
    ((panelOpen = !1), panel && (panel.hidden = !0), updateFrame());
  }
  function injectLayerRow() {
    const list = document.querySelector("[data-smoof-ui-layer-list]");
    if (
      !list ||
      !active ||
      list.querySelector(
        '[data-smoof-ui-layer="nfc"]:not([data-smoof-nfc-layer-row])',
      )
    )
      return;
    const existing = list.querySelector("[data-smoof-nfc-layer-row]");
    if (existing) {
      renderLayerVisibility(existing);
      return;
    }
    const row = document.createElement("div");
    ((row.dataset.smoofNfcLayerRow = "true"),
      (row.dataset.smoofUiLayer = "nfc"),
      (row.dataset.editable = "true"),
      (row.innerHTML = `
      <span data-smoof-ui-layer-symbol aria-hidden="true"><span data-smoof-nfc-layer-symbol>${nfcLayerIcon()}</span></span>
      <span><strong data-smoof-ui-layer-name>NFC</strong><small data-smoof-ui-layer-copy>${t("Symbol, Kreisfarbe und Position", "Icon, circle and position")}</small></span>
      <button type="button" data-smoof-ui-layer-action="nfc" data-smoof-nfc-layer-visibility aria-label="${t("Sichtbarkeit \xE4ndern", "Change visibility")}"></button>`),
      row.addEventListener("click", (event) => {
        if (
          (event.stopPropagation(),
          event.target.closest("[data-smoof-nfc-layer-visibility]"))
        ) {
          ((state.visible = !state.visible),
            saveState(),
            renderLayerVisibility(row),
            state.visible || closePanel(),
            updateAll(),
            window.SmoofDesignRenderer?.scheduleRender?.());
          return;
        }
        (document
          .querySelector('[data-smoof-ui-command-action="layers"]')
          ?.click(),
          openPanel());
      }),
      renderLayerVisibility(row));
    const qr = list.querySelector('[data-smoof-ui-layer="qr"]');
    list.insertBefore(row, qr || null);
  }
  function nfcLayerIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5.2 8.1a9.7 9.7 0 0 1 13.6 0"></path><path d="M7.9 10.9a5.8 5.8 0 0 1 8.2 0"></path><path d="M10.6 13.6a2 2 0 0 1 2.8 0"></path><circle cx="12" cy="17" r=".8" fill="currentColor" stroke="none"></circle></svg>';
  }
  function layerEyeMarkup(visible) {
    return visible
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"></path><circle cx="12" cy="12" r="2.7"></circle></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 3l18 18"></path><path d="M10.6 6.1A9 9 0 0 1 12 6c6 0 9.5 6 9.5 6a15 15 0 0 1-2.1 2.8M6.2 6.2C3.8 8 2.5 12 2.5 12s3.5 6 9.5 6a9 9 0 0 0 3.2-.6"></path></svg>';
  }
  function renderLayerVisibility(row) {
    const button = row?.querySelector("[data-smoof-nfc-layer-visibility]");
    button &&
      ((button.innerHTML = layerEyeMarkup(state.visible)),
      button.setAttribute("aria-pressed", state.visible ? "true" : "false"),
      (row.dataset.visible = state.visible ? "true" : "false"));
  }
  async function iconSvgText() {
    return (
      iconSvgPromise ||
        (iconSvgPromise = fetch(ICON_URL).then((response) => {
          if (!response.ok) throw new Error(`NFC asset ${response.status}`);
          return response.text();
        })),
      iconSvgPromise
    );
  }
  async function coloredIconImage() {
    const text = await iconSvgText(),
      doc = new DOMParser().parseFromString(text, "image/svg+xml");
    applyColours(doc.documentElement);
    const source = new XMLSerializer().serializeToString(doc.documentElement),
      url = URL.createObjectURL(
        new Blob([source], { type: "image/svg+xml;charset=utf-8" }),
      ),
      image = new Image();
    return (
      (image.decoding = "sync"),
      await new Promise((resolve, reject) => {
        ((image.onload = resolve), (image.onerror = reject), (image.src = url));
      }),
      { image, url }
    );
  }
  /*
   * Der Design-Renderer liest den NFC-Zustand direkt über SmoofNfcTools und
   * zeichnet QR und NFC in einem einzigen verbindlichen Exportdurchlauf.
   *
   * Frühere Versionen des NFC-Editors haben renderPng nachträglich ersetzt,
   * den NFC-Kreis im Renderer abgeschaltet und danach ein zweites PNG-Overlay
   * erzeugt. Dieses Overlay enthielt zusätzlich ein 150 x 150 großes weißes
   * Hilfsquadrat. Dadurch erschien die Fläche sowohl in Chrome als auch in
   * Safari im Proof.
   *
   * Der NFC-Editor verbindet sich deshalb nur noch mit dem Renderer. Er
   * verändert keine Exportmethode und zeichnet selbst keine PDF-/PNG-Ebene.
   */
  function connectRenderer() {
    const renderer = window.SmoofDesignRenderer;
    if (!renderer || renderer.__smoofNfcEditorConnected) return;
    renderer.__smoofNfcEditorConnected = !0;
    renderer.scheduleRender?.();
  }
  function syncFromSources(event) {
    const role =
      event?.target?.closest?.("[data-option-id]")?.dataset?.smoofFieldRole;
    (role === "nfcIconColor" &&
      (state.iconColor = sourceColor("nfcIconColor", state.iconColor)),
      role === "nfcCircleColor" &&
        (state.circleColor = sourceColor("nfcCircleColor", state.circleColor)),
      (role === "nfcIconColor" || role === "nfcCircleColor") &&
        (saveState(), renderPanel(!1), updateAll()));
  }
  function updateAll() {
    normalizeGeometry();
    if (
      ((active = shouldShow()),
      !sourcesHydrated &&
        fieldRoot("nfcIconColor") &&
        fieldRoot("nfcCircleColor") &&
        (propertyValue(PROPERTY_NAMES.iconColor) ||
          (state.iconColor = sourceColor("nfcIconColor", state.iconColor)),
        propertyValue(PROPERTY_NAMES.circleColor) ||
          (state.circleColor = sourceColor(
            "nfcCircleColor",
            state.circleColor,
          )),
        (sourcesHydrated = !0),
        saveState()),
      ensureFrame(),
      active || closePanel(),
      updateFrame(),
      active && state.visible)
    ) {
      (applyNfcToSvg(document), ensureLiveIcon());
      const liveSvg = frame?.querySelector("[data-smoof-nfc-live-svg]");
      liveSvg && applyColours(liveSvg);
    }
    (injectLayerRow(), panelOpen && positionPanel());
  }
  function schedule() {
    renderPending ||
      ((renderPending = !0),
      requestAnimationFrame(() => {
        ((renderPending = !1), connectRenderer(), updateAll());
      }));
  }
  (loadState(),
    (window.SmoofNfcEditor = Object.freeze({
      version: VERSION,
      getState: () => { normalizeGeometry(); return { ...state }; },
      reset: resetNfcLayout,
      schedule,
    })),
    (window.SmoofNfcTools = Object.freeze({

previewNudge(dx,dy) { if(!state.visible)return null;const p=safePosition(state.x+dx*1000,state.y+dy*1000);return {x:p.x/1000,y:p.y/1000}; },
      nudge(dx, dy) {
        if (!state.visible) return false;
        const position = safePosition(state.x + dx * 1000, state.y + dy * 1000);
        state.x = position.x; state.y = position.y;
        saveState({ syncSource: true }); updateAll();
        window.SmoofDesignRenderer?.scheduleRender?.();
        return true;
      },
      getState: () => { normalizeGeometry(); return { ...state }; },
      getHistoryState: () => { normalizeGeometry(); return { ...state }; },
      applyHistoryState(next) {
        if (!next || typeof next !== "object") return !1;
        const restoredScale = Number(next.scale);
        if (Number.isFinite(restoredScale)) state.scale = clamp(restoredScale, 0.1, 4);
        const x = Number(next.x),
          y = Number(next.y),
          position = safePosition(
            Number.isFinite(x) ? x : state.x,
            Number.isFinite(y) ? y : state.y,
          ),
          scale = Number(next.scale);
        return (
          (state.x = position.x),
          (state.y = position.y),
          Number.isFinite(scale) && (state.scale = clamp(scale, 0.1, 4)),
          typeof next.visible == "boolean" && (state.visible = next.visible),
          (state.iconColor = normalizeHex(next.iconColor, state.iconColor)),
          (state.circleColor = normalizeHex(next.circleColor, state.circleColor)),
          typeof next.circleTransparent == "boolean" &&
            (state.circleTransparent = next.circleTransparent),
          saveState({ syncSource: !0 }),
          panelOpen && renderPanel(),
          updateAll(),
          window.SmoofDesignRenderer?.scheduleRender?.(),
          window.dispatchEvent(
            new CustomEvent("smoof:nfc-visibility-changed", {
              detail: { visible: state.visible },
            }),
          ),
          !0
        );
      },
      isActive: () => active,
      isVisible: () => state.visible,
      toggleVisibility() {
        return (
          (state.visible = !state.visible),
          saveState(),
          state.visible || closePanel(),
          updateAll(),
          window.SmoofDesignRenderer?.scheduleRender?.(),
          window.dispatchEvent(
            new CustomEvent("smoof:nfc-visibility-changed", {
              detail: { visible: state.visible },
            }),
          ),
          state.visible
        );
      },
      setColor(kind, value) {
        return (
          kind === "icon" &&
            (state.iconColor = normalizeHex(value, state.iconColor)),
          kind === "circle" &&
            (state.circleColor = normalizeHex(value, state.circleColor)),
          saveState({ syncSource: !0 }),
          updateAll(),
          window.SmoofDesignRenderer?.scheduleRender?.(),
          { ...state }
        );
      },
      toggleTransparency() {
        return (
          (state.circleTransparent = !state.circleTransparent),
          saveState(),
          updateAll(),
          window.SmoofDesignRenderer?.scheduleRender?.(),
          state.circleTransparent
        );
      },
      resetPosition: resetNfcLayout,
      open: openPanel,
      close: closePanel,
    })),
    document.addEventListener(
      "input",
      (event) => {
        (syncFromSources(event), schedule());
      },
      !0,
    ),
    document.addEventListener(
      "change",
      (event) => {
        (syncFromSources(event), schedule());
      },
      !0,
    ),
    document.addEventListener(
      "pointerdown",
      (event) => {
        panelOpen &&
          !event.target.closest(
            "[data-smoof-nfc-controls], [data-smoof-nfc-frame], [data-smoof-nfc-layer-row]",
          ) &&
          closePanel();
      },
      !0,
    ),
    window.addEventListener("resize", schedule),
    window.addEventListener("scroll", () => panelOpen && positionPanel(), !0),
    window.addEventListener("smoof:product-variant-change", schedule),
    window.addEventListener("smoof:qr-geometry-change", (event) => {
      const previous = qrInnerBox(event.detail?.previous),
        current = qrInnerBox(event.detail?.current),
        wasAttached = Math.hypot(state.x - previous.centerX, state.y - previous.centerY) < 8 ||
          (state.x > previous.minX && state.x < previous.maxX && state.y > previous.minY && state.y < previous.maxY);
      if (wasAttached) {
        state.x = current.centerX;
        state.y = current.centerY;
        state.scale = clamp(Number(event.detail?.current?.scale) || 1, 0.1, 4);
        saveState();
      }
      updateAll();
      window.SmoofDesignRenderer?.scheduleRender?.();
    }),
    window.addEventListener("smoof:editor-reset-all", resetNfcLayout),
    window.addEventListener("smoof:editor-reset-layout", resetNfcLayout),
    window.addEventListener("smoof:editor-reset-content", resetNfcContent),
    window.addEventListener("smoof:editor-select", (event) => {
      String(event.detail?.id || "") === "nfc"
        ? ((panelOpen = !0), updateFrame())
        : panelOpen && closePanel();
    }),
    new MutationObserver(schedule).observe(document.body, {
      childList: !0,
      subtree: !0,
    }),
    schedule());
})();
